import {
  createBrowserHistory,
  createRootRoute,
  createRoute,
  createRouter,
  Navigate,
  Outlet,
} from '@tanstack/react-router';

import { AppShell } from './components/AppShell.js';
import { TenantsPage } from './pages/Tenants.js';
import { TenantDetailPage } from './pages/TenantDetail.js';

const rootRoute = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: () => <Navigate to="/tenants" />,
});

const tenantsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tenants',
  component: TenantsPage,
});

const tenantDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tenants/$id',
  component: function TenantDetailRoute() {
    const { id } = tenantDetailRoute.useParams();
    return <TenantDetailPage id={id} />;
  },
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  tenantsRoute,
  tenantDetailRoute,
]);

export const router = createRouter({
  routeTree,
  history: createBrowserHistory(),
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
